import { View, Text, ScrollView, Dimensions, Image, Pressable } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { Row, Table } from 'react-native-table-component'
import alert from './../alert'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useNavigation } from '@react-navigation/native';
import nameSurname from '../namesSurnames';
import GlobalStyles from './../style';
import allStats from '../allStats'
import heatmap from '../heatmap';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'
import allStatsForGame from '../allStatsForGame'

let lang = undefined;
let myActualMoney = 0;

const Market = () => {
  const navigation = useNavigation();
  const screenWidth = Dimensions.get('window').width;
  const screenHeight = Dimensions.get('window').height;

  useLayoutEffect(() => {
    navigation.setOptions({
        headerTitle: transl('HomeScreen.mercado', lang)
    })
  }, []);

  const styles = {
    container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
    header: { height: 50, backgroundColor: '#e6e6e6' },
    text: { textAlign: 'center', fontWeight: 'bold', fontSize:13 },
    row: { height: 40, backgroundColor: '#E7E6E1' }
  };


  //reading data
  const [value, setvalue] = useState('');
  const readValue = async () => {
    await AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
      if(value !== undefined)displayInfo(value)
    })
  }
  readValue()

  lang = dr.idiomas[useSelector((state) => state.language)]?.value

  let state = {
    tableHead: [transl('Roster.nombre', lang), transl('Roster.precision', lang), transl('Roster.reflejos', lang), transl('Roster.manejo', lang), transl('Roster.fuerza', lang), transl('Roster.resistencia', lang), transl('Roster.vision', lang), transl('Roster.comunicacion', lang), transl('Roster.velocidad', lang), transl('Roster.maniobra', lang), transl('Roster.estabilidad', lang), transl('Statistics.edad', lang), transl('Market.precio', lang), '$'],
    widthArr: [120, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 50]
  }

  return (
    <View>
      <View>
        <Text style={{textAlign:'center',fontWeight:'bold',fontSize:20}}>{transl('Market.galeones', lang, [displayInfo(value)])}</Text>
      </View>
      <ScrollView style={{marginBottom:20,height:screenHeight-95}} horizontal={true}>
        <View>
          <Table borderStyle={{borderWidth: 1, borderColor: '#C1C0B9'}}>
              <Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text}/>
          </Table>
          <ScrollView>
            <Table>
              {
                generatePlayersForSale(value)
              }
            </Table>
          </ScrollView>
        </View>
      </ScrollView>
    </View>
  )

  function generatePlayersForSale(value){
    if(!value || value == undefined) return <Image style={{width:screenWidth,height:screenWidth*0.6}} source={require('./../img/loading.gif')} />
    let randPlayer = []
    const name1 = "Orion Sheeper", price1 = 2150
    let player1Numbers = [76,96,89,92,87,71,93,40,40,40,23]
    //esta es la array con los JSX, no se puede enviar en el boton
    let player1 = [name1, heatmap(player1Numbers[0]),heatmap(player1Numbers[1]),heatmap(player1Numbers[2]),heatmap(player1Numbers[3]),heatmap(player1Numbers[4]),heatmap(player1Numbers[5]),heatmap(player1Numbers[6]),heatmap(player1Numbers[7]),heatmap(player1Numbers[8]),heatmap(player1Numbers[9]),player1Numbers[10]]
    //y esta es la misma array, pero con numeros crudos
    let player1Raw = [name1, player1Numbers[0],player1Numbers[1],player1Numbers[2],player1Numbers[3],player1Numbers[4],player1Numbers[5],player1Numbers[6],player1Numbers[7],player1Numbers[8],player1Numbers[9],player1Numbers[10]]
    //randPlayer.push([...player1,price1,<Button title="$$$" onPress={() => generatePlayerBuyButton(myActualMoney,price1,value,player1Raw,1,navigation)}></Button>])
    randPlayer.push([...player1,price1,<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price1,value,player1Raw,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    // <Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price1,value,player1Raw,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>
    const name2 = "Piti Times", price2 = 2150
    player1Numbers = [93,83,81,92,91,89,71,40,40,40,23]
    const player2 = [name2, heatmap(player1Numbers[0]),heatmap(player1Numbers[1]),heatmap(player1Numbers[2]),heatmap(player1Numbers[3]),heatmap(player1Numbers[4]),heatmap(player1Numbers[5]),heatmap(player1Numbers[6]),heatmap(player1Numbers[7]),heatmap(player1Numbers[8]),heatmap(player1Numbers[9]),player1Numbers[10]]
    const player2Raw = [name2, player1Numbers[0],player1Numbers[1],player1Numbers[2],player1Numbers[3],player1Numbers[4],player1Numbers[5],player1Numbers[6],player1Numbers[7],player1Numbers[8],player1Numbers[9],player1Numbers[10]]
    //randPlayer.push([...player2,price2,<Button title="$$$" onPress={() => generatePlayerBuyButton(myActualMoney,price2,value,player2Raw,1,navigation)}></Button>])
    randPlayer.push([...player2,price2,<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price2,value,player2Raw,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    const name3 = "Jos Ethman", price3 = 2150
    player1Numbers = [96,81,94,79,90,78,86,40,40,40,23]
    const player3 = [name3, heatmap(player1Numbers[0]),heatmap(player1Numbers[1]),heatmap(player1Numbers[2]),heatmap(player1Numbers[3]),heatmap(player1Numbers[4]),heatmap(player1Numbers[5]),heatmap(player1Numbers[6]),heatmap(player1Numbers[7]),heatmap(player1Numbers[8]),heatmap(player1Numbers[9]),player1Numbers[10]]
    const player3Raw = [name3, player1Numbers[0],player1Numbers[1],player1Numbers[2],player1Numbers[3],player1Numbers[4],player1Numbers[5],player1Numbers[6],player1Numbers[7],player1Numbers[8],player1Numbers[9],player1Numbers[10]]
    //randPlayer.push([...player3,price3,<Button title="$$$" onPress={() => generatePlayerBuyButton(myActualMoney,price3,value,player3Raw,1,navigation)}></Button>])
    randPlayer.push([...player3,price3,<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price3,value,player3Raw,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    const name4 = "Nick Blacksmith", price4 = 2150
    player1Numbers = [85,77,96,92,90,94,81,40,40,40,23]
    const player4 = [name4, heatmap(player1Numbers[0]),heatmap(player1Numbers[1]),heatmap(player1Numbers[2]),heatmap(player1Numbers[3]),heatmap(player1Numbers[4]),heatmap(player1Numbers[5]),heatmap(player1Numbers[6]),heatmap(player1Numbers[7]),heatmap(player1Numbers[8]),heatmap(player1Numbers[9]),player1Numbers[10]]
    const player4Raw = [name4, player1Numbers[0],player1Numbers[1],player1Numbers[2],player1Numbers[3],player1Numbers[4],player1Numbers[5],player1Numbers[6],player1Numbers[7],player1Numbers[8],player1Numbers[9],player1Numbers[10]]
    //randPlayer.push([...player4,price4,<Button title="$$$" onPress={() => generatePlayerBuyButton(myActualMoney,price4,value,player4Raw,1,navigation)}></Button>])
    randPlayer.push([...player4,price4,<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price4,value,player4Raw,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    const name5 = "Sophia Tales", price5 = 2150
    player1Numbers = [97,93,87,79,84,87,84,40,40,40,23]
    const player5 = [name5, heatmap(player1Numbers[0]),heatmap(player1Numbers[1]),heatmap(player1Numbers[2]),heatmap(player1Numbers[3]),heatmap(player1Numbers[4]),heatmap(player1Numbers[5]),heatmap(player1Numbers[6]),heatmap(player1Numbers[7]),heatmap(player1Numbers[8]),heatmap(player1Numbers[9]),player1Numbers[10]]
    const player5Raw = [name5, player1Numbers[0],player1Numbers[1],player1Numbers[2],player1Numbers[3],player1Numbers[4],player1Numbers[5],player1Numbers[6],player1Numbers[7],player1Numbers[8],player1Numbers[9],player1Numbers[10]]
    //randPlayer.push([...player5,price5,<Button title="$$$" onPress={() => generatePlayerBuyButton(myActualMoney,price5,value,player5Raw,1,navigation)}></Button>])
    randPlayer.push([...player5,price5,<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price5,value,player5Raw,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    for(let i = 0; i < 10; i++){
      let playerGap = [];
      let nameRand = nameSurname()
      playerGap.push(nameRand)
      const randHabilities = generateRandomNumber(30,90,7)
      let allSkills = [];
      for(let j = 0; j < randHabilities.length; j++) allSkills[j] = heatmap(randHabilities[j])
      allSkills = [...allSkills, ...[heatmap(40),heatmap(40),heatmap(40)]]
      playerGap.push(...allSkills)

      let age = generateRandomNumber(21,24)
      playerGap.push(age)

      let price = (randHabilities[0] + randHabilities[1] + randHabilities[2] + randHabilities[3] +randHabilities[4])*2
      playerGap.push(Math.ceil(price))

      let playerX = [nameRand,...randHabilities, 40,40,40,age]
      playerGap.push(<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,price,value,playerX,1,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>)

      randPlayer.push(playerGap)
    }

    //ordenamos los jugadores que hay hasta ahora
    randPlayer = randPlayer.sort(function(a, b) { return b[10] - a[10]; });

    let broomsForSale = [
      ["Saeta de Fuego Suprema",96,92,90,650],
      ["Saeta de Fuego",91,82,79,525],
      ["Yajirushi",86,97,95,650],
      ["Hachiroku",72,93,94,525],
      ["Pua de Transilvania",93,92,93,650],
      ["Turbo XXX",91,98,89,650],
      ["Varapidos",89,91,98,650],
      ["Saeta de Trueno VII",98,89,91,650],
      ["Sobrevuelo Australiano 50", 87,85,77,500],
      ["Eje de Roble 79",32,67,44,200],
      ["Flecha de Plata",41,48,62,200],
      ["Estrella Fugaz",42,36,31,100],
      ["Nimbus 1000",63,49,65,325],
      ["Nimbus 1001",68,56,71,375],
      ["Nimbus 1500",72,62,76,400],
      ["Nimbus 1700",77,65,78,425],
      ["Nimbus 2000",81,72,83,450],
      ["Nimbus 2001",83,75,84,475],
      ["Barredora 1",48,52,47,250],
      ["Barredora 2",51,56,51,275],
      ["Barredora 3",53,62,57,325],
      ["Barredora 5",60,65,62,375],
      ["Barredora 6",68,71,66,400],
      ["Barredora 7",76,76,68,425],
      ["Barredora 11",77,79,74,450],
      ["Barrestrella XXI",86,88,84,525],
      ["Cometa 140",47,71,60,350],
      ["Cometa 180",53,73,65,375],
      ["Cometa 220",57,74,69,400],
      ["Cometa 260",66,79,71,425],
      ["Cometa 290",67,84,75,450],
      ["Escoba de Juguete",10,10,10,20],
    ]
    //air wave gold -> ventisca de oro
    //moontrimmer -> corte de luna
    //bluebottle -> Mosca Azul
    //sky scythe -> Segadora Celeste
    broomsForSale = broomsForSale.sort(function(a, b) { return b[4] - a[4]; });
    for(const element of broomsForSale){
      randPlayer.push([element[0],"---","---","---","---","---","---","---",heatmap(element[1]),heatmap(element[2]),heatmap(element[3]),"---",element[4],<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,element[4],value,[element[0],element[1],element[2],element[3]],2,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    }

    //[nombre, precio, state]
    let objectsForSale = [
      [transl('Market.pocionCurativa', lang), 650, 1],
      [transl('Market.felixFelicis', lang), 4000, 2],
      [transl('Market.fragmentoPiedra', lang), 7000, 3],
      [transl('Market.pocionMultijugos', lang), 1600, 4],
      [transl('Market.gragea', lang), 850, 5],
      [transl('Market.hechizoConfundus', lang),1800, 6],
      //["Polvo Herrero para Escobas",350,7]
    ];

    objectsForSale.sort(function(a,b){return a[1]-b[1]})
    for(const element of objectsForSale){
      randPlayer.push([element[0],"---","---","---","---","---","---","---","---","---","---","---",element[1],<Pressable style={GlobalStyles.buttonSellPlayer} onPress={() => generatePlayerBuyButton(myActualMoney,element[1],value,[element[0],element[2]],3,navigation)}><Text style={GlobalStyles.textForButtonMain}>$$$</Text></Pressable>])
    }

    let limiteRespectoObj = randPlayer.length - objectsForSale.length;

    return randPlayer.map((rowData, index) => (
                  <Row
                    key={index}
                    data={rowData}
                    widthArr={state.widthArr}
                    textStyle={{textAlign:'center'}}
                    style={[
                      (index<5 && index%2) && {backgroundColor: '#ffff66'},
                      (index<5 && !(index%2)) && {backgroundColor: '#ffff99'},
                      (index>4 && index<15 && index%2) && {backgroundColor: '#ffb366'},
                      (index>4 && index<15 && !(index%2)) && {backgroundColor: '#ffcc99'},
                      (index>14 && index<limiteRespectoObj && !(index%2)) && {backgroundColor: '#ffffff'},
                      (index>limiteRespectoObj-1 && (index%2)) && {backgroundColor: '#66a3ff'},
                      (index>limiteRespectoObj-1 && !(index%2)) && {backgroundColor: '#99c2ff'},
                      {paddingVertical:6}
                    ]}
                  />
                ))
  }

  function displayInfo(data){
    if(data === undefined || !data) {
      return transl('General.cargando', lang)
    }
    data = data != null ? JSON.parse(data) : null
  
    myActualMoney = data.profile.money
  
    return data.profile.money
  }
}

function generateRandomNumber(from, to, howMany = 1) {
  const diferencia = to - from + 1;
  let numbers = [];
  for(let i = 0; i < howMany; i++) {
    numbers[i] = Math.floor(Math.random() * diferencia + from);
  }
  return numbers;
}

function comprarJugador(cost,data,player,type,navigation) {
  //hacemos la resta del dinero
  myActualMoney = myActualMoney - cost;
  data = data != null ? JSON.parse(data) : null
  data.profile.money = myActualMoney;

  //ponemos el jugador en la plantilla (generando agresividad y lo que haga falta)
  //hay que crear un objeto
  
  if(type==1) {
    let thisPlayer = {}
    thisPlayer = {
      name: player[0],
      skills: [
        player[1],player[2],player[3],player[4],player[5],player[6],player[7]
      ],
      broom: [
        player[6],player[7],player[8],99
      ],
      hiddenSkills: [...generateRandomNumber(1,99,2)],
      stats: allStats(),
      inGameStats: allStatsForGame(),
      injury: 0,
      age: player[9],
      nickname:''
    }
    data.teams[0].players.push(thisPlayer)
  } else if (type==2) {
    let thisBroom = {}
    thisBroom = {
      name: player[0],
      velocidad: player[1],
      maniobra: player[2],
      estabilidad: player[3]
    }
    data.others.brooms.push(thisBroom)
  } else {
    if(!(data.profile && 'objects' in data.profile)) data.profile.objects = {felixFelicis:0,piedraFilosofal:0,pocionCurativa:0,pocionMultijugos:0,hechizoConfundus:0,polvoHerrero:0};
    console.log(player)
    if (player[1] == 1) {
      data.profile.objects.pocionCurativa++
    } else if(player[1] == 2) {
      data.profile.objects.felixFelicis++
    } else if(player[1] == 3) {
      data.profile.objects.piedraFilosofal++
    } else if(player[1] == 4) {
      data.profile.objects.pocionMultijugos++
    } else if(player[1] == 5) {
      data.profile.objects.gragea++
    } else if(player[1] == 6) {
      data.profile.objects.hechizoConfundus++
    } else if(player[1] == 7) {
      data.profile.objects.polvoHerrero++;
    }
  }
  

  //y guardamos en JSON
  const storeData = async (equipos) => {
    try {
      const jsonValue = JSON.stringify(equipos)
      await AsyncStorage.setItem('equipos', jsonValue)
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }

  storeData(data);

  //mensajito de que todo va bien
  alert(transl('General.info', lang),transl('Market.comprado', lang,[player[0]]),[
    {
      text: transl('General.OK', lang),
      onPress: () => void(0),
      style: "cancel"
    },
  ])
  navigation.navigate('HomeScreen')
}


function generatePlayerBuyButton (myMoney, cost, data,player,type,navigation) {
  //type nos dice si es jugador o es escoba, u objeto
  //type 1: jugador
  //type 2: escoba
  //type 3: objeto
  return alert(transl('Market.comprar', lang),transl('Market.quieresComprar', lang,[player[0]]),[
      {
        text: transl('General.cancelar', lang),
        onPress: () => void(0),
        style: "cancel"
      },
      {
        text: transl('General.OK', lang), onPress: () => {
          if(myMoney >= cost){
            comprarJugador(cost,data,player,type,navigation)
          } else {
            alert(transl('General.info', lang),transl('Market.noTienesSuficiente', lang),[
              { text: transl('General.OK', lang), onPress: () => void(0) }
            ])
          }
        }
      }
    ])
}

export default Market